import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { CSSTransition } from "react-transition-group"

import { useAppData } from "~/api/globals"
import { Button } from "~/components/Button/Button"
import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { detectLang } from "~/i18n"

import styles from "./index.module.css"

const text = {
  ru: (
    <>
      Мы используем cookie на этом сайте,
      <br />
      чтобы сделать его ещё лучше, удобнее и красивее.
    </>
  ),
  en: (
    <>
      We use cookies on this website
      <br />
      to make it better, more convenient and stunning.
    </>
  ),
}

const button = {
  ru: `Мне понятно`,
  en: `Got it`,
}

export const Cookies = ({ lang }) => {
  const [showCookies, setShowCookies] = useState(false)
  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang || i18n.language || lang

  useEffect(() => {
    setShowCookies(!localStorage.getItem("cookies"))
  }, [])

  const clickHandler = () => {
    localStorage.setItem("cookies", true)
    setShowCookies(false)
  }

  return (
    <CSSTransition
      classNames={{
        enter: styles.WrapperEnter,
        exitActive: styles.WrapperExitActive,
      }}
      in={showCookies}
      timeout={1000}
      unmountOnExit
    >
      <div className={styles.Wrapper}>
        <div className="bb-container">
          <div className={styles.Inner}>
            <div className={styles.Text}>{text[currLang]}</div>
            <Button className={styles.Button} onClick={clickHandler}>
              {button[currLang]}
            </Button>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}
